import React from 'react';
import TopBanner from '../components/TopBanner';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Registration from '../components/Registration';
import About from '../components/About';
import Subjects from '../components/Subjects';
import Classes from '../components/Classes';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Founders from '../components/Founders';
import Pikachuians from '../components/Pikachuians';
import SuccessStories from '../components/SuccessStories';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import FloatingCTA from '../components/FloatingCTA';

export default function Home() {
  return (
    <div className="bg-[#FFF8EC]">
      <TopBanner />
      <Navbar />
      <Hero />
      <Registration />
      <Stats />
      <About />
      <Subjects />
      <Classes />
      <Features />
      <HowItWorks />
      <Founders />
      <Pikachuians />
      <SuccessStories />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <FloatingCTA />
    </div>
  );
}
